module.exports = __webpack_public_path__ + "img/avatar7.2bbc3942.png";